<template>
  <b-modal
    ref="resetSessionsConfirm"
    centered
    size="md"
    title="Wait! Are you sure?"
    header-text-variant="danger"
    footer-bg-variant=""
    hide-header
    scrollable
    @hidden="unselectUser()">

    <b-alert
      variant="light-danger"
      show
      class="mb-8">
      <p class="font-size-lg mb-0">
        When resetting sessions, all current sessions of a given user will lead to the inability to use them. For repeated uses, it will need to reuse the static token to create new sessions.
      </p>
    </b-alert>

    <div class="font-weight-bold mb-2">User Details</div>
    <b-list-group
      v-if="selectedUserId !== null"
      class="mb-6">
      <b-list-group-item class="d-flex align-items-center">
        User ID
        <b-badge
          variant="light"
          class="ml-auto font-size-xs">{{ selectedUser.code }}</b-badge>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Reseller ID
        <span class="ml-auto">{{ selectedUser.item_id }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Devices
        <span class="ml-auto">{{ selectedUser.devices }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Created
        <span class="ml-auto">{{ selectedUser.created | moment("DD.MM.YYYY, HH:mm") }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Expiry
        <span class="ml-auto">{{ selectedUser.expiry | moment("DD.MM.YYYY, HH:mm") }}</span>
      </b-list-group-item>
    </b-list-group>

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('resetSessionsConfirm')">
          Cancel
        </b-button>
        <b-button
          variant="danger"
          size="md"
          class="ml-auto"
          :disabled="usersResponses('resetUserSessions')"
          @click="resetUserSessions(), hideModal('resetSessionsConfirm')">
          Yes, reset all sessions
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { RESET_USER_SESSIONS, UNSELECT_USER } from '@/core/services/store/users.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showModal, hideModal } from '@/core/utils'
import moment from 'moment'

export default {
  name: 'ModalResetSessions',
  data() {
    return {
      suspensionReason: '',
      
      showModal,
      hideModal,
      moment,
    }
  },
  computed: {
    ...mapGetters([
      'selectedUser',
      'selectedUserId',
      'usersResponses',
    ]),
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    unselectUser() {
      this.$store.commit(UNSELECT_USER)
    },

    resetUserSessions() {
      this.$store.dispatch(RESET_USER_SESSIONS, {
        user_id: this.selectedUserId,
      })
    },
  }
}
</script>
